import { Component, OnInit } from '@angular/core';
import { WizardService } from  '../wizard.service';
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  constructor(private  wizardService:  WizardService) { }

  ngOnInit() {
  }

  testRun(){
    console.log("testRun clicked");
    this.wizardService.testRunWizard().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
    
  }
  
  testCreateFolder(){
    console.log("testCreateFolder clicked");
    this.wizardService.testCreateFolder().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
  
  testWriteFile(){
    console.log("testWriteFile clicked");
    this.wizardService.testWriteFile().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
  
  testRestartService(){
    console.log("testRestartService clicked");
    this.wizardService.testRestartService().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
  
  testStartCore(){
    console.log("testStartCore clicked");
    this.wizardService.testStartCore().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
  
  testDependency(){
    console.log("testDependency clicked");
    this.wizardService.testDependencyMock().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
  
  testLogin(){
    console.log("testLogin clicked");
    this.wizardService.testLogin().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
  
  testGetUser(){
    console.log("testGetUser clicked");
    this.wizardService.testGetUser().subscribe( data => {
      console.log(data);
    },err=>{
      console.log("error:"+err);
    });
  }
}
